import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SANSKRITI_LOGO from "../assets/images/SANSKRITI_LOGO.png";
import sanskriti_faded from "../assets/images/sanskriti-faded-back.webp";
import Call from "../assets/images/call.png";
import Email from "../assets/images/email.png";
import Website from "../assets/images/website.png";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllClasses,
  getStudentById,
  setGradingSubjects,
  setTheoreticalSubjects,
} from "../features/studentSlice";
import { useSearchParams } from "react-router-dom";
// import { backgroundImage } from "html2canvas/dist/types/css/property-descriptors/background-image";

const ReportCard = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const studentID = searchParams.get("id");

  const currentStudentData = useSelector(
    (state) => state.student.current_student_data
  );
  
 const formatedDOB = () => {
    if(!currentStudentData?.dob) return "N/A";
    if(currentStudentData?.dob.includes("-")){
      const [year, month, day] = currentStudentData.dob.split("-");
      return `${day}/${month}/${year}`
    }
    if(typeof currentStudentData?.dob == "string") return currentStudentData?.dob;
  };

  const classesData = useSelector((state) => state.student.classes);
  const theoreticalSubjects = useSelector(
    (state) => state.student.theoritical_subjects
  );
  const gradingSubjects = useSelector(
    (state) => state.student.grading_subjects
  );

  const generatePDF = () => {
    const input = document.getElementById("pdf-content");

    // Calculate content width and height
    const contentWidth = input.scrollWidth;
    const contentHeight = input.scrollHeight;

    // Add some padding to the dimensions
    const padding = 10; // Adjust as needed
    const pdfWidth = contentWidth + padding;
    const pdfHeight = contentHeight + padding;

    html2canvas(input, { width: pdfWidth, height: pdfHeight }).then(
      (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: canvas.width > canvas.height ? "landscape" : "portrait",
          unit: "px",
          format: [pdfWidth, pdfHeight],
        });

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        const filename =
          currentStudentData && currentStudentData.scholar_name
            ? currentStudentData.scholar_name + ".pdf"
            : "reportcard.pdf";

        pdf.save(filename);
      }
    );
  };

  useEffect(() => {
    if (!studentID) return;
    dispatch(getStudentById(studentID));
    dispatch(getAllClasses());
  }, [studentID]);

  useEffect(() => {
    if (!currentStudentData) return;

    const currentClass =
      classesData &&
      classesData.find((el) => el.name == currentStudentData.class);
    dispatch(setTheoreticalSubjects(currentClass?.theoretical_subjects));
    dispatch(setGradingSubjects(currentClass?.grading_subjects));
  }, [currentStudentData]);

  let term1_count = 0;
  let term2_count = 0;

  const theoreticalRows =
    currentStudentData &&
    theoreticalSubjects?.map((subject, i) => {
      const calculateGrade = (total) => {
        if (total > 90) {
          return "A1";
        } else if (total > 80) {
          return "A2";
        } else if (total > 70) {
          return "B1";
        } else if (total > 60) {
          return "B2";
        } else if (total > 50) {
          return "C1";
        } else if (total > 40) {
          return "C2";
        } else if (total >= 35) {
          return "D";
        } else {
          return "F";
        }
      };

      const calculateTotal = (term, subject) => {
        // Ensure each value is a valid number, and if not, default to 0
        const preTestValue =
          Number(currentStudentData?.pre_test?.[term]?.[subject]) || 0;
        const noteBookValue =
          Number(currentStudentData?.note_book?.[term]?.[subject]) || 0;
        const subEnrichmentValue =
          Number(currentStudentData?.sub_enrichement?.[term]?.[subject]) || 0;
        const halfYearlyValue =
          Number(currentStudentData?.half_yearly?.[term]?.[subject]) || 0;

        // Perform addition after ensuring all values are numbers
        return (
          preTestValue + noteBookValue + subEnrichmentValue + halfYearlyValue
        );
      };

      term1_count += calculateTotal("term1", subject);
      term2_count += calculateTotal("term2", subject);
      const renderTableCells = (term) => {
        return (
          <>
            <td className="px-2 pb-4 text-center text-2xl font-semibold">
              {currentStudentData?.pre_test?.[term]?.[subject]}
            </td>
            <td className="px-2 pb-4 text-center text-2xl font-semibold">
              {currentStudentData?.note_book?.[term]?.[subject]}
            </td>
            <td className="px-2 pb-4 text-center text-2xl font-semibold">
              {currentStudentData?.sub_enrichement?.[term]?.[subject]}
            </td>
            <td className="px-2 pb-4 text-center text-2xl font-semibold">
              {currentStudentData?.half_yearly?.[term]?.[subject]}
            </td>
            <td className="px-2 pb-4 text-center text-2xl font-semibold">
              {calculateTotal(term, subject)}
            </td>
            <td className="px-2 pb-4 text-center text-2xl font-semibold ">
              {calculateGrade(calculateTotal(term, subject))}
            </td>
          </>
        );
      };

      return (
        <tr key={i}>
          <td className="font-bold text-xl text-center pb-4">{i + 1}</td>
          <td className="px-2 text-xl font-semibold pb-4 uppercase">
            {subject.replace(/_/g, " ")}
          </td>
          {renderTableCells("term1")}
          {/* term-2 */}
          {renderTableCells("term2")}
        </tr>
      );
    });
  const gradingRows = gradingSubjects?.map((subject, i) => {
    const renderTableCells = (term) => {
      return (
        <>
          <td className="px-2 pb-4 text-center text-2xl font-semibold">
            {currentStudentData?.pre_test?.[term]?.[subject]}
          </td>
          <td className="px-2 pb-4 text-center text-2xl font-semibold">
            {currentStudentData?.note_book?.[term]?.[subject]}
          </td>
          <td className="px-2 pb-4 text-center text-2xl font-semibold">
            {currentStudentData?.sub_enrichement?.[term]?.[subject]}
          </td>
          <td className="px-2 pb-4 text-center text-2xl font-semibold">
            {currentStudentData?.half_yearly?.[term]?.[subject]}
          </td>
          <td className="px-2 pb-4 text-center text-2xl font-semibold"></td>
          <td className="px-2 pb-4 text-center text-2xl font-semibold">
            {currentStudentData?.half_yearly?.[term]?.[subject]}
          </td>
        </>
      );
    };

    return (
      <tr key={i}>
        <td className="font-bold text-xl text-center pb-4">
          {theoreticalSubjects?.length + i + 1}
        </td>
        <td className="px-2 text-xl font-semibold pb-4 uppercase">
          {subject.replace(/_/g, " ")}
        </td>
        {renderTableCells("term1")}
        {/* term-2 */}
        {renderTableCells("term2")}
      </tr>
    );
  });

  return (
    <div className="relative w-fit overflow-y-hidden">
      <div className="fixed top-0 left-0 w-screen h-screen bg-white z-100">
        <img
          src={SANSKRITI_LOGO}
          width="350"
          height="350"
          className="mx-auto"
          alt="Logo"
        />
        <button
          onClick={generatePDF}
          className="text-3xl font-bold text-white bg-orange-500 hover:bg-orange-600 px-4 py-2 rounded-lg flex justify-center items-center mx-auto mt-6"
        >
          Generate Report Card PDF
        </button>
      </div>

      <div id="pdf-content">
        <div className="flex items-start px-20 mb-10">
          <div className="">
            <img src={SANSKRITI_LOGO} width="350" height="350" alt="Logo" />
          </div>

          <div className="w-[80%]">
            <h1 className="text-[7rem] font-semibold text-[#C12525]">
              <span className="studiomn pl-32">SANSKRITI </span>....
            </h1>
            <h2 className="handel font-semibold text-[#42454A] text-[4rem] text-center -ml-12">
              PUBLIC SCHOOL
            </h2>
            <h3 className="text-2xl font-semibold text-center -ml-60">
              Ranidiha, Near Divya Nagar, Gorakhpur (U.P) 273010
            </h3>
          </div>
        </div>
        <div className="px-72 -mt-6 ">
          <p className="gap-6 flex space-x-8 justify-center">
            <span className="bg-[#667BB2] text-white text-xl font-bold rounded-md px-4 pb-5">
              Affiliation No. 2131044
            </span>
            <span className="bg-[#C12525] text-white text-xl font-bold rounded-md px-4 pb-5">
              Session : 2023-2024
            </span>
            <span className="bg-[#667BB2] text-white text-xl font-bold rounded-md px-4 pb-5">
              School Code - 70513
            </span>
          </p>
        </div>

        <div className="bg-gradient-to-r from-[#E67716] to-[#667BB2] mb-8 mt-16 pb-8 flex items-center justify-center">
          <h2 className="text-center text-white font-semibold text-4xl">
            PROGRESS REPORT CARD
          </h2>
        </div>

        <div className="px-20 bg-no-repeat bg-contain bg-center"> <table className="w-[100%] mb-2 !border-0">
            <tr className="!border-0">
              <td className="!border-0 text-2xl py-2 font-semibold">
                Scholar's Name : <span className="font-medium">{currentStudentData?.scholar_name}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
              <td className="!border-0 text-2xl py-2 font-semibold">
                S.R. No. : <span className="font-medium">{currentStudentData?.s_r_no}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
            </tr>
            <tr className="!border-0">
              <td className="!border-0 text-2xl py-2 font-semibold">
                Father's Name : <span className="font-medium">{currentStudentData?.father_name}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
              <td className="!border-0 text-2xl py-2 font-semibold">
                Date of Birth : <span className="font-medium">{formatedDOB()}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
            </tr>
            <tr className="!border-0">
              <td className="!border-0 text-2xl py-2 font-semibold">
                Mother's Name : <span className="font-medium">{currentStudentData?.mother_name}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
              <td className="!border-0 text-2xl py-2 font-semibold">
                Contact No. : <span className="font-medium">{currentStudentData?.contact_number}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
            </tr>
            <tr className="!border-0">
              <td className="!border-0 text-2xl py-2 font-semibold">
                Class & Section : <span className="font-medium">{currentStudentData?.class} -
                {" "}{currentStudentData?.section.toUpperCase()}</span>
              </td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
              <td className="!border-0 text-2xl py-2 font-semibold"></td>
            </tr>
          </table>
          <h2 className="text-2xl mt-12 mb-5 font-semibold">
            Part 1 : Scholastic Areas
          </h2>
          <div
            className="bg-center bg-contain bg-no-repeat"
            style={{ backgroundImage: `url(${sanskriti_faded})` }}
          >
            <table className="w-[100%] border-0">
              <tr className="!border-0 mb-5">
                <th
                  colSpan="8"
                  className="text-center bg-[#A9D5FF] pb-5 text-2xl !border-0 !border-r-[1px]"
                >
                  TERM - I
                </th>
                <th
                  colSpan="6"
                  className="text-center bg-[#A9D5FF] text-2xl pb-5 !border-0"
                >
                  TERM - II
                </th>
              </tr>
              <tr className="py-4 !border-0">
                <th
                  colSpan="8"
                  className="text-center pb-5 text-xl !border-0"
                ></th>
                <th
                  colSpan="6"
                  className=" text-center text-xl pb-5 !border-0"
                ></th>
              </tr>
              <tr>
                <th className="text-center text-xl font-extrabold pb-4 w-20">S.No.</th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  SUBJECT
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  PA I (10)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Note Book (5)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Subject Enrichment (5)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Half Yearly (80)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Mark Obtained (100)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">Grade</th>

                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  PA II (10)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Note Book (5)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Subject Enrichment (5)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Annual Exam (80)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">
                  Mark Obtained (100)
                </th>
                <th className="text-center text-xl font-extrabold pb-4 px-4">Grade</th>
              </tr>
              {theoreticalRows}
              {gradingRows}
              <tr>
                <th colSpan={3} className="px-4 pb-4 font-bold text-xl">
                  Grand Total
                </th>
                <th colSpan={5} className="pb-4 text-xl font-bold text-end pr-3">
                  {theoreticalSubjects?.length
                    ? `${term1_count} / ${theoreticalSubjects.length * 100}`
                    : ""}
                </th>
                <th colSpan={8} className="pb-4 text-xl font-bold text-end pr-3">
                  {theoreticalSubjects?.length
                    ? `${term2_count} / ${theoreticalSubjects.length * 100}`
                    : ""}
                </th>
              </tr>
              <tr>
                <th colSpan={3} className="px-4 pb-4 font-bold text-xl">
                  Percentage
                </th>
                <th colSpan={5} className="pb-4 font-bold text-xl text-end pr-3">
                {theoreticalSubjects?.length
                    ? (((term1_count / theoreticalSubjects.length) * 100) / 100).toFixed(2)
                    : ""}{" "}
                  %
                </th>
                <th colSpan={8} className="pb-4 font-bold text-xl text-end pr-3">
                {theoreticalSubjects?.length
                    ? (((term2_count / theoreticalSubjects.length) * 100) / 100).toFixed(2)
                    : ""}{" "}
                  %
                </th>
              </tr>
              <tr>
                <th
                  colSpan={3}
                  className="!border-t-0 px-4 pb-4 font-bold text-xl">
                  Teacher's Remark
                </th>
                <th colSpan={13} className="pl-3 pb-4 text-2xl">
                  {currentStudentData?.class_teacher_remark}
                </th>
              </tr>
            </table>
            {/* <table class="w-[100%] !border-t-0">
              <tbody>
                <tr class="">
                  <td class="lg:w-[15.3%] !border-t-0 px-4 pb-4 font-bold text-lg">
                    Teacher's Remark
                  </td>
                  <td class="pb-4 pl-3 border-0 text-lg font-bold ">
                    {currentStudentData?.class_teacher_remark}
                  </td>
                </tr>
              </tbody>
            </table> */}
            <table className="w-[100%] mb-4 !border-0 mt-12" border="1">
              <tr className="!border-0">
                <th className="text-center bg-[#A9D5FF] font-bold text-lg pb-4 pt-2 !border-0">
                  Co-Scholastic Areas :
                </th>
              </tr>
            </table>
            <table className="w-[100%] border-0">
              <tr>
                <th className="text-center text-xl font-extrabold w-[4rem] pb-4">
                  S.No.
                </th>
                <th className="px-2 pb-4 text-xl font-extrabold">
                  Co-Scholastic Areas :
                </th>
                <th className="px-2 pb-4 text-xl font-extrabold text-center">
                  TERM - I
                </th>
                <th className="px-2 pb-4 text-xl font-extrabold text-center">
                  TERM - II
                </th>
              </tr>
              <tr>
                <td className="font-semibold text-xl text-center pb-4">1</td>
                <td className="font-semibold text-xl px-2 pb-4">
                  Work Education (or Pre - vocational Education)
                </td>
                <td className="font-semibold text-xl px-2 pb-4 text-center">
                  {currentStudentData?.co_scholastic?.term1?.work_education}
                </td>
                <td className="font-semibold text-xl px-2 pb-4 text-center">
                  {currentStudentData?.co_scholastic?.term2?.work_education}
                </td>
              </tr>
              <tr>
                <td className="font-semibold text-xl text-center pb-4">2</td>
                <td className="font-semibold text-xl px-2 pb-4">Art Education</td>
                <td className="font-semibold text-xl px-2 pb-4 text-center">
                  {currentStudentData?.co_scholastic?.term1?.art_education}
                </td>
                <td className="font-semibold text-xl px-2 pb-4 text-center">
                  {currentStudentData?.co_scholastic?.term2?.art_education}
                </td>
              </tr>
              <tr>
                <td className="font-semibold text-xl text-center pb-4">3</td>
                <td className="font-semibold text-xl px-2 pb-4">
                  Health & Physical Education
                </td>
                <td className="font-semibold text-xl px-2 pb-4 text-center">
                  {currentStudentData?.co_scholastic?.term1?.health_education}
                </td>
                <td className="font-semibold text-xl px-2 pb-4 text-center">
                  {currentStudentData?.co_scholastic?.term2?.health_education}
                </td>
              </tr>
              {/* discipline combine */}
              <tr className="bg-white !border-0">
                <th class="!border-0 py-4 border-x-0"></th>
              </tr>
              <tr>
                <th className="text-center text-xl w-[4rem] font-extrabold pb-4">S.No.</th>
                <th className="w-[65.6%] pb-4"></th>
                <th className="px-2 text-xl text-center font-extrabold pb-4">
                  TERM - I
                </th>
                <th className="px-2 text-xl text-center font-extrabold  pb-4">
                  TERM - II
                </th>
              </tr>
              <tr>
                <td className="text-center text-xl font-semibold pb-4">1</td>
                <td className="px-2 font-bold text-xl pb-4">Discipline</td>
                <td className="pb-4 text-xl font-semibold text-center">
                  {currentStudentData?.co_scholastic?.term1?.discipline}
                </td>
                <td className="pb-4 text-xl font-semibold text-center">
                  {currentStudentData?.co_scholastic?.term2?.discipline}
                </td>
              </tr>
            </table>

            <table className="w-[100%] my-3">
              <tr className="">
                <th className="px-2 pt-4 text-xl pb-5">
                  Promotion Granted to Class:<span className="font-semibold"> {currentStudentData?.promoted_to_class}</span>
                </th>
                <td className="!border-b-0"></td>
                <td className="!border-b-0"></td>
                <td className="!border-b-0"></td>
              </tr>
              <tr className="w-full">
                <th className="px-2 pt-4  text-xl pb-5 w-[30%]">
                  School will reopen on:
                  <span className="font-semibold"> {"4th April 2024"} </span>
                </th>
                <td className="text-center font-bold text-2xl !border-t-0 w-[17.5%]">
                  Parent’s Sign
                </td>
                <td className="text-center font-bold text-2xl !border-t-0 w-[17.5%]">
                  Class Teacher’s Sign
                </td>
                <td className="text-center font-bold text-2xl !border-t-0 w-[17.5%]">
                  Principal’s Sign
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="mt-6 px-60">
          <h3 className="text-center text-2xl font-bold pb-3">
            Instructions
          </h3>
          <p className="text-center text-xl">
            Grading Scale for Scholastic Areas : Grades are awarded an 8 -
            point grading scale as follows -{" "}
          </p>
          <table className="mt-4 w-[100%]">
            <tr>
              <th className="text-center text-lg font-semibold pb-4">
                MARKS RANGE
              </th>
              <th className="text-center text-lg font-semibold pb-4">GRADE</th>
              <th className="text-center text-lg font-semibold pb-4">
                MARKS RANGE
              </th>
              <th class="text-center text-lg font-semibold pb-4">GRADE</th>
            </tr>

            <tr>
              <td className="text-center text-lg font-semibold pb-4">
                91 - 100
              </td>
              <td className="text-center text-lg font-semibold pb-4">A1</td>
              <td className="text-center text-lg font-semibold pb-4">
                51 - 60
              </td>
              <td className="text-center text-lg font-semibold pb-4">C1</td>
            </tr>

            <tr>
              <td className="text-center text-lg font-semibold pb-4">
                81 - 90
              </td>
              <td className="text-center text-lg font-semibold pb-4">A2</td>
              <td className="text-center text-lg font-semibold pb-4">
                41 - 50
              </td>
              <td className="text-center text-lg font-semibold pb-4">C2</td>
            </tr>

            <tr>
              <td className="text-center text-lg font-semibold pb-4">
                71 - 80
              </td>
              <td className="text-center text-lg font-semibold pb-4">B1</td>
              <td className="text-center text-lg font-semibold pb-4">
                35 - 40
              </td>
              <td className="text-center text-lg font-semibold pb-4">D</td>
            </tr>

            <tr>
              <td className="text-center text-lg font-semibold pb-4">
                61 - 70
              </td>
              <td className="text-center text-lg font-semibold pb-4">B2</td>
              <td className="text-center text-lg font-semibold pb-4">
                34 & BELOW
              </td>
              <td className="text-center text-lg font-semibold pb-4">
                F (Needs improvement)
              </td>
            </tr>
          </table>

          <div className="mt-12 flex justify-between">
            <div className="flex items-center">
              <img
                src={Call}
                width="16"
                height="16"
                className="h-5 w-5 mt-1 mr-2"
                alt=""
              />
              <p className="text-xl mb-5">+918528836338,9076706020 </p>
            </div>
            <div className="flex items-center">
              <img
                src={Email}
                width="16"
                height="16"
                className="h-5 w-5 mt-1 mr-2"
                alt=""
              />
              <p className="text-xl mb-5">sanskritips.gkp@gmail.com </p>
            </div>
            <div className="flex items-center">
              <img
                src={Website}
                width="16"
                height="16"
                className="h-5 w-5 mt-1 mr-2"
                alt=""
              />
              <p className="text-xl mb-5">https://www.spsgkp.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCard;
